import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { bibShape } from '@bibliocommons/bc-prop-types';

import { createBibFieldSelector, selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import SubjectAndGenre, { fieldsShape } from './SubjectAndGenre';

const CATEGORY = 'SUBJECTGENRE';
const selectSubjectsAndGenres = createBibFieldSelector(CATEGORY);

export class SubjectAndGenreContainer extends React.PureComponent {
  render() {
    const { fields, trackFieldItemClick } = this.props;

    return fields?.size ? (
      <SubjectAndGenre
        {...this.props}
        trackFieldItemClick={(fieldItem, fieldValue) => trackFieldItemClick(CATEGORY, fieldItem, fieldValue)}
      />
    ) : null;
  }
}

SubjectAndGenreContainer.propTypes = {
  bib: bibShape.isRequired,
  fields: fieldsShape.isRequired,
  trackFieldItemClick: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('id');

  return {
    bib: selectBibEntities(state).get(metadataId),
    fields: selectSubjectsAndGenres(state)
  };
};

export default connect(mapStateToProps)(SubjectAndGenreContainer);
